import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import moment from "moment"

import GuestLayout from "../components/GuestLayout"

import * as cartSlice from "../store/cart"
import * as orderApis from "../utilities/apis/order"
import { getSrc, isDeal, isProduct, url } from "../utilities/enumerations/constants"

const Checkout = () => {
  const cartState = useSelector((state) => state.cart)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleDecrement = async (item) => {
    dispatch(cartSlice.handleCartDecrement(item.slug))
  }

  const handleIncrement = async (item) => {
    if (cartState.cartById[item.slug] >= 5) return alert("For more than 5 quantity please contact our support on whatsapp")
    dispatch(cartSlice.handleCartIncrement(item.slug))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      setLoading(true)

      const products = cartState.cart.filter((lineitem) => isProduct(lineitem.type)).map((lineitem) => ({
        cost: lineitem.cost,
        price: lineitem.price,
        quantity: cartState.cartById[lineitem.slug],
        product_id: lineitem.id
      }))
      const orderDeals = cartState.cart.filter((lineitem) => isDeal(lineitem.type))
      const deals = []

      orderDeals.forEach((lineitem) => lineitem.deal_products.map((dealProduct) => {
        deals.push({
          cost: dealProduct.product.cost,
          price: dealProduct.product.price,
          quantity: dealProduct.quantity,
          deal_cost: lineitem.cost,
          deal_price: lineitem.price,
          deal_discount: lineitem.discount,
          deal_quantity: cartState.cartById[lineitem.slug],
          swap: dealProduct.swap || 0,
          product_id: dealProduct.product_id,
          deal_id: lineitem.id
        })
      }))
      const lineitems = products.concat(deals)

      const payload = {
        zone: {
          name: "N/A"
        },
        customer: {
          mobile: e.target.mobile.value,
          address: e.target.address.value
        },
        order: {
          discount: 0,
          customer_note: e.target.note.value,
          ship_datetime: moment().add(2, "days").format("YYYY-MM-DD HH:mm"),
          total: cartState.cart.reduce((p, c) => p += ((c.price - (c.discount || 0)) * cartState.cartById[c.slug]), 0),
          cost: cartState.cart.reduce((previous, current) => previous += (cartState.cartById[current.slug] * current.cost), 0),
          commission: 0
        },
        order_lineitems: lineitems
      }

      if (e.target.bid.value) payload.order.discount = payload.order.total - parseFloat(e.target.bid.value)

      const response = await orderApis.checkout(payload)
      if (!response.status) throw new Error(response.message)

      dispatch(cartSlice.emptyCart())
      alert("Order placed")
      navigate("/")
    } catch (error) {
      alert(error.message)
    } finally {
      setLoading(false)
    }
  }

  if (!cartState.cart.length) return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <div className="container">
        <section className="py-3">
          <p className="lead text-body-emphasis fw-bold">Checkout</p>
          <div className="card rounded-4 shadow-none my-3 text-center">
            <div className="card-body p-5">
              <div className="d-flex flex-column gap-3 align-items-center">
                <p className="display-1 text-body-tertiary m-0"><i className="bi bi-bag-x"></i></p>
                <p className="lead text-body-tertiary fw-semibold m-0">No deals or products selected</p>
                <Link to="/#deals" className="btn btn-light-theme rounded-3">Explore Products</Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </GuestLayout>
  )

  return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <div className="container">
        <section className="py-3">
          <p className="lead text-body-emphasis fw-bold">Checkout</p>
          <form method="post" onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-8">
                <div className="border border-bottom-0 rounded-top-4">
                  <div className="d-flex flex-column">
                    {cartState.cart.map((item, index) => {
                      let border = ""
                      if (index !== cartState.cart.length - 1) border = "border-bottom"

                      const price = item.price - (item.discount || 0)

                      return (
                        <div key={`checkout-item-${index}`} className={`d-flex gap-3 justify-content-between align-items-center ${border} p-3`}>
                          <img src={getSrc(item.thumbnail_url)} alt={item.title} className="border rounded-3" width={40} height={40} />
                          <div className="flex-grow-1">
                            <p className="small text-body-emphasis fw-bold m-0">{item.title}</p>
                          </div>
                          <div className="d-flex gap-1 align-items-center">
                            <p className="small text-body-tertiary fw-semibold m-0">Rs. {price.toFixed(2)}</p>
                            <p className="small text-body-tertiary fw-semibold m-0">x {cartState.cartById[item.slug]} =</p>
                            <p className="small text-body-tertiary fw-semibold m-0">Rs. {(cartState.cartById[item.slug] * price).toFixed(2)}</p>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
                <div className="bg-secondary border border-bottom-0 p-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <p className="text-body-tertiary fw-bold m-0">Offer your Price</p>
                    <input type="number" name="bid" className="form-control form-control-sm w-25 rounded-3" step="0.01" disabled={loading} />
                  </div>

                  <div className="alert alert-warning rounded-3 m-0">
                    <p className="small m-0"><span className="fw-bold">Important Note</span>: Phonics can cancel or decline an order if the price listed is wrong or too low.</p>
                  </div>
                </div>
                <div className="bg-light border rounded-bottom-4 p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="text-body-tertiary fw-bold m-0">Total</p>
                    <p className="text-body-tertiary fw-bold m-0">Rs. {(cartState.cart.reduce((p, c) => p += c.price * cartState.cartById[c.slug], 0) - cartState.cart.reduce((p, c) => p += c.discount * cartState.cartById[c.slug] || 0, 0)).toFixed(2)}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex flex-column gap-3">
                  <div className="card rounded-4 shadow-none">
                    <div className="card-body py-4">
                      <div className="mb-3">
                        <label htmlFor="mobile" className="form-label">Mobile No</label>
                        <input type="text" name="mobile" className="form-control rounded-3" id="mobile" disabled={loading} required />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="address" className="form-label">Address</label>
                        <input type="text" name="address" className="form-control rounded-3" id="address" disabled={loading} required />
                      </div>
                      <div>
                        <label htmlFor="note" className="form-label">Note</label>
                        <textarea name="note" className="form-control rounded-3" id="note" rows={4} disabled={loading}></textarea>
                      </div>
                    </div>
                  </div>

                  <div className="alert alert-danger rounded-4 m-0">
                    <p className="fst-italic">* Please note if you want to change the products according to your need you can mention it in the notes, additional charges may apply</p>
                    <p className="text-end fst-italic m-0">اگر آپ اپنی ضرورت کے مطابق مصنوعات کو تبدیل کرنا چاہتے ہیں تو آپ اس کا ذکر نوٹ میں کرسکتے ہیں، اضافی چارجز لاگو ہوسکتے ہیں</p>
                  </div>

                  <button type="submit" className="btn btn-theme rounded-4 w-100" disabled={loading}>Place Order</button>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </GuestLayout>
  )
}

export default Checkout